import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Button} from "primereact/button";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";

import HelpComponent from "../HelpComponent";

const _FM_GuestinforequestShowComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id,action} = useParams();
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "guest-information-request-page/" + id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
          window.App.setState({rerenderBerthList: false})
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
  }, [window.App.state.rerenderBerthList === true])

  return (
    <>
      <div className={"p-grid p-mt-3"}>
        <div className={"p-col p-col-align-center"}>
          <h2 className={"p-m-0"}>
        {formData.name || t('guestinforequest_show')}
          </h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"}>
          <Button type="button" aria-label={t('edit')}
                  icon={"pi pi-pencil"}
                  onClick={() => {
                    navigate('/guest-information-request-page/update/' + id)
                  }}
                  className="p-button-warning p-ml-2">
          </Button>
          <Button type="button"
                  icon={"pi pi-times"}
                  onClick={() => {
                    navigate(-1)
                  }}
                  className="p-button-secondary close p-ml-2">
          </Button>
        </div>
      </div>
      <div className={"p-grid"}>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('created_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('updated_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
      </div>
      <Panel className={"p-mt-3"}>
        {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
        <HelpComponent type={"show_box"}/>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-12"}>
            <div className="p-field p-fluid">
              <label htmlFor="customer_required_fields">{t('customer_required_fields')}</label>
              <span className="p-d-block p-text-bold">
                {Array.isArray(formData.customer_required_fields)
                  ? formData.customer_required_fields.map((fieldName) => t(fieldName)).join(", ")
                  : ""}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="pimary_color">{t('primary_color')}</label>
              <span className="p-d-block p-text-bold">
                <div style={{backgroundColor: formData.primary_color, width: '100%', height: '30px'}}>
                </div>
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="secondary_color">{t('secondary_color')}</label>
              <span className="p-d-block p-text-bold">
                <div style={{backgroundColor: formData.secondary_color, width: '100%', height: '30px'}}>
                </div>
              </span>
            </div>
          </div>
          {formData.image_url &&
            <div className={"p-col-12 p-lg-6"}>
              <div className="p-field p-fluid">
                <label htmlFor="image">{t('image')}</label>
                <span className="p-d-block p-text-bold">
                {formData?.image_url?.toString().includes('.') &&
                  <img
                    src={process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST.toString().replace("/api/", "") + formData.image_url}
                    className={"w-100"}/>
                }
              </span>
              </div>
            </div>
          }
          {formData.girp_additional_fields && formData.girp_additional_fields[0] &&
            <>
              <div className={"p-col-12 p-lg-12"}>
                <div className="p-field p-fluid">
                  <label htmlFor="girp_additional_fields">{t('girp_additional_fields')}</label>
                  <span className="p-d-block p-text-bold">
                    {formData.girp_additional_fields.map((field, index) => {
                      return (
                        <span className={"p-mr-1"}>
                          {field.name},
                        </span>
                      )
                    })}
              </span>
                </div>
              </div>
            </>
          }
        </div>
      </Panel>
    </>
  )
}
export default withTranslation('common')(_FM_GuestinforequestShowComponent);
